// 导入请求公用方法
import fetch from '@/utils/fetch'
/**
 * 获取分类列表
 * @params：{json}
 * @returns：{json}
 */
export const findSortList = (params) => {
        return fetch({
            url: '/por-basis/por/basis/demadDall/getSorts',
            method: 'get',
            params
        })
    }
    /**
     * 获取众包市场需求列表
     * @params：{json}
     * @returns：{json}
     */
export const getSupplyList = (params) => {
        return fetch({
            url: '/por-basis/por/basis/demadDall//fistPageList',
            method: 'get',
            params
        })
    }
    /**
     * 获取供需需求详情
     * @params：{json}
     * @returns：{json}
     */
export const getSupplyDetail = (params) => {
    return fetch({
        url: '/por-basis/por/basis/demadDall/auth/getDetailById',
        method: 'get',
        params
    })
}

/**
 * 获取最新动态
 * @params：{json}
 * @returns：{json}
 */
export const getdemadDall = () => {
        return fetch({
            url: '/por-basis/por/basis/demadDall/LatestList',
            method: 'get',
        })
    }
    /**
     * 发布需求
     * @params：{json}
     * @returns：{json}
     */
export const addSupply = (data) => {
        return fetch({
            url: '/por-basis/por/basis/demadDall/auth/insert',
            method: 'post',
            data
        })
    }
    /**
     * 需求对接
     * @params：{json}
     * @returns：{json}
     */
export const addDemandOrder = (data) => {
        return fetch({
            url: '/por-basis/por/basis/demadDall/auth/addDemandOrder',
            method: 'post',
            data
        })
    }
    // 查看需求是否对接
export const checkIsRecommon = (params) => {
    return fetch({
        url: '/por-basis/por/basis/demadDall/auth/checkConnect',
        method: 'get',
        params
    })
}

// 获取省份
export const getProvince = (params) => {
        return fetch({
            url: '/por-basis/por/basis/location/provinceList',
            method: 'get',
            params
        })
    }
    // 获取需求更多列表分类
export const getCategory = (params) => {
    return fetch({
        url: '/por-basis/por/basis/demadDall/getSorts',
        method: 'get',
        params
    })
}

// 需求更多列表查询
export const getCategoryList = (params) => {
    return fetch({
        url: '/por-basis/por/basis/demadDall/listBysortId',
        method: 'get',
        params
    })
}

// 发布服务判断是否是服务商
export const isServer = (params) => {
        return fetch({
            url: '/por-user/api/por/pUserCertificates/checkUserIdentityIsService',
            method: 'get',
            params
        })
    }
    /**
     * 查询是否认证
     * @params：{json}
     * @returns：{json}
     */
export const getUserAuthentication = () => {
    return fetch({
        url: '/por-user/api/por/pUserCertificates/auth/getCurrentIdentityCertificates',
        method: 'get',
    })
}